import React from 'react'

const VideoDisplay = ({src,title,publisher}) => {
  
  return (
    <div className='flex justify-center gap-8 py-10 md:px-7'>
      <div 
        key = {src}
        className="w-full max-w-full sm:max-w-[700px] md:max-w-[500px] lg:max-w-[1800px] mx-auto aspect-video"
        style={{ maxHeight: "80vh" }} >
        <video 
          controls 
          autoPlay 
          className="rounded-lg">
          <source src={src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <p className='mt-6'>{title}</p>
        <p className='text-gray-200 text-sm'>{publisher}</p>
      </div>
    </div>
  )
}

export default VideoDisplay
